(function ($) {
    "use strict";
    if ($('.product-image-gallery').length) {
        var countImg = $('.product-image-gallery img').length;

        if ( countImg == 2 || countImg == 1 || countImg == 0) {
            $('.prevCircle').hide();
            $('.nextCircle').hide();
        }
    }

    $(".product-image.product-image-verticle .next").on("click", function () {
        if (!$(".product-image-gallery").is(':animated')) {
            var left = $(".product-image-gallery .gallery-image:first-child");
            var clone = $(".product-image-gallery .gallery-image:first-child").clone();
            clone.removeClass("visible");
            $(".product-image-gallery .gallery-image:nth-child(2)").addClass("visible");
            clone.appendTo(".product-image-gallery");

            $(".product-image-gallery").animate({
                "left": '-=500'
            }, 0, function () {
                left.remove();

                var object = $('.product-image-gallery .gallery-image');

                for (var i = 1; i < object.length; i++){

                    if ($(object[i]).hasClass('visible')){
                        $(object[i]).removeClass('visible');
                    }
                }
                $(".product-image-gallery").animate({
                    "left": "+=500"
                }, 0);
            });
        }
    });

   $(".product-image.product-image-verticle .previous").on("click", function () {
        if (!$(".product-image-gallery").is(':animated')) {
            var left = $(".product-image-gallery .gallery-image:last-child");
            var clone = $(".product-image-gallery .gallery-image:last-child").clone();
            $(".product-image-gallery .gallery-image:first-child").removeClass("visible");
            clone.addClass("visible");
            clone.prependTo(".product-image-gallery");
            // var src = $('#image-main').attr('src');
            // $('.product-image-gallery img.gallery-image.visible').attr('data-src', src);

            $(".product-image-gallery").animate({
                "left": '+=500'
            }, 0, function () {
                left.remove();

                $(".product-image-gallery").animate({
                    "left": "-=500"
                }, 0);
            });
        }
    });

    $(document).ready(function(){
        //$('.product-image .product-image-gallery').lightGallery({thumbnail: false});
        //$('.product-image .product-image-gallery').zoom();
    });

    $(window).on("load resize scroll",function(e){
        if ($('.pd-shop').length) {
            var width_img = $('.category-products .products-grid .item .item-area .product-figure .pd-shop')[0].getBoundingClientRect().width;
            $('.category-products .products-grid .item .item-area .product-figure .pd-shop').css("height", width_img);
        }
        // if ( $('.product-img-box').length ) {
        //     var width_box = $('.product-img-box .product-img-list .product-image-gallery')[0].getBoundingClientRect().width;
        //     $('.product-img-box .product-img-list .product-image-gallery .gallery-image').css("height", width_box);
        // }
    });
    $(window).on("load resize",function(e){
        if ($('.pd-home').length) {
            var width_img2 = $('.category-products .products-grid .item .item-area .product-figure .pd-home')[0].getBoundingClientRect().width;
            $('.category-products .products-grid .item .item-area .product-figure .pd-home').css("height", width_img2);
        }
    });

})(jQuery);

